// extracted by mini-css-extract-plugin
export default {"button":"InviteTeam_button__1BYAV","modal":"InviteTeam_modal__61+6u","manageaccess":"InviteTeam_manageaccess__gL+86"};